import {
  ILineParams,
  IParamsToSend
} from '@base/@types/providers/Kpi/LogisticProvider'

export const formatParamsModalKpiToSend = (
  dataLine: ILineParams,
  paramsToSend: IParamsToSend
) => {
  const paramsResponse = JSON.parse(
    localStorage.getItem('@kpiLogisticParamsResponse:')
  )

  const saleIndicatorsRequestModal: IParamsToSend = {
    empresa: {
      ids: paramsToSend.empresa?.agrupar
        ? [dataLine['empresa-codigo-id']]
        : paramsToSend.empresa?.ids,
      agrupar: paramsToSend.empresa?.agrupar
    },
    loja: {
      ids: paramsToSend.loja?.agrupar
        ? [dataLine['cd-loja-codigo-id']]
        : paramsToSend.loja?.ids,
      agrupar: paramsToSend.loja?.agrupar
    },
    gerenteCategoria: {
      ids: paramsToSend.gerenteCategoria?.agrupar
        ? dataLine['gerente-categoria-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.gerenteCategoriaDescricao ===
                  dataLine['gerente-categoria-id']
              )?.gerenteCategoriaId
            ]
          : []
        : paramsToSend.gerenteCategoria?.ids,
      agrupar: paramsToSend.gerenteCategoria?.agrupar
    },
    gerenteProduto: {
      ids: paramsToSend.gerenteProduto?.agrupar
        ? dataLine['gerente-produto-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.gerenteProdutoDescricao ===
                  dataLine['gerente-produto-id']
              )?.gerenteProdutoId
            ]
          : []
        : paramsToSend.gerenteProduto?.ids,
      agrupar: paramsToSend.gerenteProduto?.agrupar
    },
    categoriaCompacta: {
      ids: paramsToSend.categoriaCompacta?.agrupar
        ? [dataLine['categoria-compacta-codigo-id']]
        : paramsToSend.categoriaCompacta?.ids,
      agrupar: paramsToSend.categoriaCompacta?.agrupar
    },
    fornecedor: {
      ids: paramsToSend.fornecedor?.agrupar
        ? [dataLine['fornecedor-id']]
        : paramsToSend.fornecedor?.ids,
      agrupar: paramsToSend.fornecedor?.agrupar
    },
    subCategoria: {
      ids: paramsToSend.subCategoria?.agrupar
        ? [dataLine['subcategoria-codigo-id']]
        : paramsToSend.subCategoria?.ids,
      agrupar: paramsToSend.subCategoria?.agrupar
    },
    periodo: {
      inicio: paramsToSend.periodo?.inicio,
      final: paramsToSend.periodo?.final,
      agrupar: paramsToSend.periodo?.agrupar
    }
  }

  return saleIndicatorsRequestModal
}
